export default "__VITE_ASSET__D5G8yb9R__"